var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.679,
    height: 21.509,
    viewBox: "0 0 28.679 21.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-video-call",
    className: "cls-1",
    d: "M8.66,9A4.677,4.677,0,0,0,4,13.66V25.849a4.677,4.677,0,0,0,4.66,4.66H20.849a4.677,4.677,0,0,0,4.66-4.66v-.968l5.541,3.324a1.076,1.076,0,0,0,1.629-.923V12.226a1.076,1.076,0,0,0-1.629-.923l-5.541,3.324V13.66A4.677,4.677,0,0,0,20.849,9Zm0,2.151H20.849a2.494,2.494,0,0,1,2.509,2.509V25.849a2.494,2.494,0,0,1-2.509,2.509H8.66a2.494,2.494,0,0,1-2.509-2.509V13.66A2.494,2.494,0,0,1,8.66,11.151Zm21.868,2.976V25.383l-5.019-3.011V17.137Z",
    transform: "translate(-4 -9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOutline);
export default __webpack_public_path__ + "static/media/videoOutline.6dacc01c80dd83ba14f01f63a3042671.svg";
export { ForwardRef as ReactComponent };